/** @jsxImportSource @emotion/react */
import {
  ListItem as MuiListItem,
  ListItemIcon as MuiListItemIcon,
  ListItemText as MuiListItemText,
} from '@material-ui/core';
import { theme } from 'global';
import { FC } from 'react';
import * as styles from './MenuListItem.styles';
import { MenuListItemProps } from './MenuListItemProps';
import { HighlightTag } from 'components';

const MenuListItem: FC<MenuListItemProps> = ({
  item,
  onClick,
  isDrawerOpen = false,
  selected = false,
  children,
  className,
  ...rest
}) => {
  return (
    <MuiListItem
      button
      key={item.value}
      css={[styles.listItem(selected), styles.drawerItem(isDrawerOpen)]}
      onClick={onClick}
      disableRipple
      id={`menu-item-${item.value}`}
      className={className}
      {...rest}
    >
      <MuiListItemIcon css={styles.listItemIcon(isDrawerOpen, selected)}>
        {item.icon && (
          <item.icon
            width={24}
            height={24}
            fill={
              selected ? theme.colors.primary.medium : theme.colors.neutral[600]
            }
          />
        )}
      </MuiListItemIcon>
      <MuiListItemText
        primary={item.text}
        css={[
          styles.listItemText(isDrawerOpen, !!item.tag),
          styles.drawerText(isDrawerOpen),
        ]}
      />
      {item.tag && isDrawerOpen && (
        <HighlightTag label={item.tag} expiryDate={item.tagExpiry} />
      )}
      {children && children}
    </MuiListItem>
  );
};

export default MenuListItem;
